/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import Complex128 from './../../../../float64/ctor';
import real from './../../../../float64/real';
import imag from './../../../../float64/imag';


// MAIN //

/**
* Scales a double-precision complex floating-point number by a real-valued double-precision floating-point scalar constant.
*
* @param {number} alpha - scalar constant
* @param {Complex128} z - complex number
* @returns {Complex128} result
*
* @example
* import Complex128 from '@stdlib/complex/float64/ctor';
*
* var z = new Complex128( 5.0, 3.0 );
*
* var out = scale( 5.0, z );
* // returns <Complex128>[ 25.0, 15.0 ]
*/
function scale( alpha, z ) {
	return new Complex128( real( z ) * alpha, imag( z ) * alpha );
}


// EXPORTS //

export default scale;
